/** @format */
import React, { FunctionComponent, useState } from 'react';
import { SimCardServiceTypeItem } from '../../../../interfaces/collections/SimCardServiceInterface';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import { OplSimCardServiceTypeInfoBox } from './OplSimCardServiceTypeInfoBox';
import { ServicesMvneType } from '../../../../modules/lib/hooks/useOperatorType';
import { OplSimCardServiceTypeSdgParams } from './OplSimCardServiceTypeSdgParams';
import { OplSimCardServiceTypeItemEdit } from './OplSimCardServiceTypeItemEdit';
import { roles, UserRoleHelper } from '../../../../helpers/UserRoleHelper';
import OplSimCardServiceTypeParamItem from './OplSimCardServiceTypeParamItem';
import { useSelector } from 'react-redux';
import { FeaturesServiceReducerType } from '../../../../modules/features/FeaturesReducers';
import { OplSimCardServiceTypeBmeParams } from './OplSimCardServiceTypeBmeParams';
import { useSimCardServiceGroupList } from '../../../../modules/lib/hooks/useSimCardServiceGroupList';
import SimCardServiceTypeMappedCustomParams from '../mappedCustom/SimCardServiceTypeMappedCustomParams';
import CardHeader from '../../../../components/Heading/CardHeaderExt';
import { ViewList } from '@material-ui/icons';
import Card from '../../../../components/Card/Card';
import CardBody from '../../../../components/Card/CardBody';
import CustomTextButtom from '../../../../components/Buttons/CustomTextButton';
import { SmsMessageWithSystemLanguageDialog } from './SmsMessage/SmsMessageWithSystemLanguageDialog';
import { Auth } from '../../../../modules/auth/Auth';
import { CheckMccCode } from './Check/CheckMccCode';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import { CheckZoneCode } from './Check/CheckZoneCode';

type OplSimCardServiceTypeItemType = {
    simCardServiceType: SimCardServiceTypeItem;
    reload: () => void;
};

export const OplSimCardServiceTypeItem: FunctionComponent<OplSimCardServiceTypeItemType> = ({ simCardServiceType, reload }): React.ReactElement => {
    const allowedParams = UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS_GET);
    const allowTypeParams = UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_GET);
    const [openEdit, setOpenEdit] = useState(false);
    const [openEditMessage, setOpenEditMessage] = useState(false);
    const [typeMessage, setTypeMessage] = useState(-1);

    const { simCardServiceTypeAllowedParamsCollection } = useSelector(
        (state: { serviceReducer: FeaturesServiceReducerType }) => state.serviceReducer
    );

    const groupList = useSimCardServiceGroupList([]);

    const title = simCardServiceType.serviceType === ServicesMvneType.BME ? 'prov:feature.bme_service' : 'prov:feature.service';

    return (
        <React.Fragment>
            <GridContainer spacing={1}>
                <GridItem xs={6}>
                    <GridContainer spacing={1}>
                        <GridItem xs={12}>
                            <OplSimCardServiceTypeInfoBox
                                simCardServiceType={simCardServiceType}
                                title={title}
                                openEdit={(): void => setOpenEdit(true)}
                            />
                        </GridItem>
                        {simCardServiceType.serviceType !== ServicesMvneType.SDG && (
                            <GridItem xs={12} style={{ marginTop: '20px' }}>
                                <Card>
                                    <CardHeader icon={<ViewList />} trans={'prov:feature.sms_message'} />
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} style={{ textAlign: 'right', marginBottom: '10px' }}>
                                                {simCardServiceType.singleShotFlag && (
                                                    <CustomTextButtom
                                                        callback={(): void => {
                                                            setTypeMessage(1);
                                                            setOpenEditMessage(true);
                                                        }}
                                                        label="prov:feature.sms_message_configure"
                                                        size="sm"
                                                    />
                                                )}
                                                <CustomTextButtom
                                                    callback={(): void => {
                                                        setTypeMessage(2);
                                                        setOpenEditMessage(true);
                                                    }}
                                                    label="prov:feature.sms_message_for_nai_configure"
                                                    size="sm"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        )}
                        {simCardServiceType.mainname === 'serviceBOS' && (
                            <GridItem xs={12} style={{ marginTop: '20px' }}>
                                <Card>
                                    <CardHeader icon={<ViewList />} trans={'prov:feature.sms_message'} />
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} style={{ textAlign: 'right', marginBottom: '10px' }}>
                                                <CustomTextButtom
                                                    callback={(): void => {
                                                        setTypeMessage(3);
                                                        setOpenEditMessage(true);
                                                    }}
                                                    label="prov:feature.sms_message_configure"
                                                    size="sm"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        )}
                        {allowTypeParams && simCardServiceType.serviceType !== ServicesMvneType.MCBME && simCardServiceTypeAllowedParamsCollection && (
                            <GridItem xs={12} style={{ marginTop: '20px' }}>
                                <OplSimCardServiceTypeParamItem
                                    simCardServiceType={simCardServiceType}
                                    simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                                />
                            </GridItem>
                        )}
                    </GridContainer>
                    <SmsMessageWithSystemLanguageDialog
                        open={openEditMessage}
                        close={(): void => {
                            setOpenEditMessage(false);
                        }}
                        simCardServiceType={simCardServiceType}
                        platformResellerId={Auth.getUserPlatformResellerId()}
                        type={typeMessage}
                    />
                </GridItem>
                <GridItem xs={6}>
                    {allowedParams && simCardServiceType.serviceType === ServicesMvneType.SDG && (
                        <OplSimCardServiceTypeSdgParams simCardServiceType={simCardServiceType} />
                    )}
                    {allowedParams && simCardServiceType.serviceType === ServicesMvneType.BME && (
                        <OplSimCardServiceTypeBmeParams simCardServiceType={simCardServiceType} />
                    )}
                    {allowedParams && simCardServiceType.serviceType === ServicesMvneType.MCBME && (
                        <SimCardServiceTypeMappedCustomParams simCardServiceType={simCardServiceType} />
                    )}
                    {simCardServiceType.mccCheck && simCardServiceType.allowWaitingForActivation  && (
                        <CheckMccCode
                            simCardServiceTypeId={simCardServiceType.id}
                            simCardServiceType={FormGeneralHelper.changeAdescomApiIriToBaseApiIri(simCardServiceType['@id'])}
                        />
                    )}
                    {simCardServiceType.zoneCheck && simCardServiceType.allowWaitingForActivation  && (
                        <CheckZoneCode
                            simCardServiceTypeId={simCardServiceType.id}
                            simCardServiceType={FormGeneralHelper.changeAdescomApiIriToBaseApiIri(simCardServiceType['@id'])}
                        />
                    )}
                </GridItem>
            </GridContainer>
            <OplSimCardServiceTypeItemEdit
                simCardServiceType={simCardServiceType}
                serviceGroupList={groupList}
                openEdit={openEdit}
                close={(): void => {
                    reload();
                    setOpenEdit(false);
                }}
            />
        </React.Fragment>
    );
};
